import {
  createDocumentFlowOrgBeforeLoad,
  createDocumentFlowOrgLoader,
  createDocumentFlowOrgComponent,
} from '@/shared/utils/route-utils/document-flow-route-config'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_quote-flow/org/$orgId')({
  beforeLoad: createDocumentFlowOrgBeforeLoad,
  loader: createDocumentFlowOrgLoader,
  component: createDocumentFlowOrgComponent('/_quote-flow/org/$orgId'),
})
